import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainBody from "../../../components/MainBody/MainBody";
import MainTabList from "../../../components/MainBody/MainTabList";
import InitialCDD from "./InitialCDD";
import OngoingCDD from "./OngoingCDD";
import DynamicTooltip from "../../../components/DynamicToolTip";

const tabsKey = [
  {
    name: "Initial",
    tabName: "initial",
    value: 1,
  },
  {
    name: "Ongoing",
    tabName: "ongoing",
    value: 2,
  },
];

const CDD = ({ readAccess, writeAccess }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("childTab") || "initial";

  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab,
  )?.value;

  const [activeTab, setActiveTab] = useState(
    defaultActiveKey ? defaultActiveKey : 1,
  );

  useEffect(() => {
    navigate(
      `?tab=cdd&childTab=${
        tabsKey?.find((item) => item?.value === activeTab)?.tabName
      }`,
      {
        replace: true,
      },
    );
  }, [activeTab, navigate]);

  return (
    <>
      <MainBody
        search={false}
        loading={false}
        innerBody={true}
        actionAlign={"end"}
        actionContent={""}
      >
        <div className="relative">
          <MainTabList
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabsKey={tabsKey}
            className={""}
          >
            {activeTab === 1 ? (
              <InitialCDD readAccess={readAccess} writeAccess={writeAccess} />
            ) : activeTab === 2 ? (
              <OngoingCDD readAccess={readAccess} writeAccess={writeAccess} />
            ) : (
              ""
            )}
          </MainTabList>
          <div className="absolute top-0 right-0 flex items-center gap-2">
            Contact Data Mismatch:
            <DynamicTooltip
              position="bottomRight"
              content={
                <div className="flex flex-col gap-2 w-[150px]">
                  <div className="flex items-center gap-1.5">
                    <div
                      className={`min-h-5 min-w-2 bg-red-500 dark:bg-red-500`}
                    />
                    Did Not Match
                  </div>
                  <div className="flex items-center gap-1.5">
                    <div
                      className={`min-h-5 min-w-2 bg-yellow-300 dark:bg-yellow-500`}
                    />
                    Updated as per the ID document.
                  </div>
                </div>
              }
            />
          </div>
        </div>
      </MainBody>
    </>
  );
};

export default CDD;
